<template>
  <div class="statistics">
    <template v-for="(item, index) in countList">
      <div :key="index" class="statistics-item">
        <b class="ball" :style="`background-color: ${item.color}`"></b>
        <span class="title">{{item.name}}</span>
        <span v-if="item.notNumber" class="content" :style="`color: ${item.color}`"> {{item.count}}</span>
        <count-to v-else class="content" :style="`color: ${item.color}`"
                  :start-val='0' :end-val='item.count' :duration='1000' :decimals='item.decimals || 0'/>
      </div>
    </template>
  </div>
</template>

<script>
  import CountTo from "vue-count-to";
  export default {
    name: "Statistics",
    props: {countList: Array},
    components: {CountTo},
  }
</script>

<style scoped lang="scss">
.statistics {
  .statistics-item {
    display: inline-block;
    margin-right: 15px;
    .ball {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-right: 5px;
      background-color: $home-color;
    }
    .title {
      box-sizing: border-box;
      text-align: left;
      line-height: 40px;
      font-size: 14px;
    }
    .content {
      font-size: 18px;
      color: $home-color;
    }
  }
}
</style>
